module.exports = __webpack_public_path__ + "images/material-adjust.svg";